import { Alert, AlertDescription, AlertTitle } from '@multaqa/ui/components/ui/alert'
import { Button } from '@multaqa/ui/components/ui/button'

interface InlineQueryErrorProps {
  title: string
  description: string
  retryLabel?: string
  onRetry?: () => void
}

/**
 * A non-Suspense query error for list and other inline screen regions. The
 * caller supplies translated copy and owns the retry operation.
 */
export function InlineQueryError({
  title,
  description,
  retryLabel,
  onRetry,
}: InlineQueryErrorProps) {
  return (
    <Alert severity="danger">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
      {retryLabel && onRetry ? (
        <Button type="button" variant="outline" onClick={onRetry}>
          {retryLabel}
        </Button>
      ) : null}
    </Alert>
  )
}
